import {IModalServiceInstance} from 'angular-ui-bootstrap';
import ITranslateService = angular.translate.ITranslateService;

export class ShowTooltipController {

    static $inject = ['$uibModalInstance', '$translate', 'text'];

    text: string;

    constructor(private $uibModalInstance: IModalServiceInstance, $translate: ITranslateService, text: string) {
        if (text !== undefined && text !== null) {
            this.text = $translate.instant(text);
        } else {
            this.text = 'test';
        }
    }

    ok(): void {
        this.$uibModalInstance.close();
    };
}



// WEBPACK FOOTER //
// ./src/app/core/dialog/ShowTooltipController.ts